module.exports = __webpack_public_path__ + "static/img/tabsBg2.3d4a5f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tabsBg2.png
// module id = LKLv
// module chunks = 18